import * as React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import emptyBox from '../_image/empty_box.svg';
import emptyBoxColor from '../_image/empty_box_color.svg';
import useEventListener from '@use-it/event-listener';
import { makeStyles } from '@mui/styles';
import { Link } from 'react-router-dom';
import { gsap } from 'gsap';
import { Box } from '@mui/material';


const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: 60,
    padding: 50,
    height: 'calc(100vh - 50px - 240px)',
    backgroundColor: theme.palette.background.paperOpacity,
    borderRadius: theme.borderRadius.large,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 30,
    [theme.breakpoints.down('md')]: {
      marginBottom: 20,
      height: 'calc(100vh - 200px)',
      backgroundColor: theme.palette.background.paper,
    },
    '& .txt': {
      fontSize: 20,      
      textAlign: 'center',
    },
    '& .btn': {
      paddingBottom: 80,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '&>a>div': {
        padding: '6px 24px',
        color: theme.palette.primary.main,
        fontSize: 14,
        fontWeight: 600,
        borderRadius: '99em',
        border: `1px solid ${theme.palette.line.input}`,
        backgroundColor: theme.palette.background.paper,
        cursor: 'pointer',
        transition: '.3s',
        '&:hover': {
          border: `1px solid ${theme.palette.primary.main}`,
          backgroundColor: theme.palette.background.hover,
        },
      },
    },
    '& .emptyBox': {
      flex: 1,
    },
  },
  images: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& img': {
      maxWidth: '100%',
    },
    '&>div': {
      position: 'relative',
      '&>div.box': {

      },
      '&>div.color': {
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 10,
      },
    },
  },
}));


/** 無商品資料 */
export function EmptyBox() {

  const classes = useStyles();
  const md = useMediaQuery((theme) => theme.breakpoints.up('md'), {noSsr: true});
  const [coords, setCoords] = React.useState([0, 0]);
  // console.log('coords', coords);
  
  useEventListener('mousemove', ({ clientX, clientY }) => {
    setCoords([clientX, clientY]);
  });

  React.useEffect(() => {
    if(md) {
      let bWidth = window.document.body.clientWidth;
      let bCenter = bWidth / 2;
      let num = 50;
      let move = 0;
      let p = null;
      if(coords[0] < bCenter) {
        p = Math.round(((bCenter - coords[0]) / bCenter) * 100) / 100;
        move = -(Math.abs(num * p));
      } else {
        p = Math.round(((coords[0] - bCenter) / bCenter) * 100) / 100;
        move = Math.abs(num * p);
      }
      gsap.to('#emptyBoxColor', {
        ease: 'power2.out',
        x: move
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coords]);


  return (
    <Box className={classes.root}>
      <Box className='emptyBox'>
        <Box className={classes.images}>
          <Box>
            <Box className='box'>
              <img src={emptyBox} alt='' />
            </Box>
            <Box id='emptyBoxColor' className='color'>
              <img src={emptyBoxColor} alt='' />
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className='txt'>無商品資料，請重新選擇。</Box>
      <Box className='btn'>
        <Link to={'/'}>
          <Box>回{global.domain.webSiteName}首頁</Box>
        </Link>
      </Box>
    </Box>
  )
}